import { cn } from '@/shared/utils';

import Button from '../ui/button';

const LocationPermissionUI = ({ onRequestPermission, permissionDenied }) => {
  return (
    <div
      className={cn(
        'text-center my-8 h-[calc(100vh/3)]',
        'flex flex-col justify-center items-center',
        'border border-white/20 rounded-sm p-4'
      )}
    >
      <h1 className="text-xl">Grant permission to access your location</h1>
      {!permissionDenied && (
        <>
          <p className="text-[#859692] mb-6">
            This is required to display the closest bowling centers to you
          </p>
          <Button onClick={() => onRequestPermission()} variant="primary">
            Grant permission
          </Button>
        </>
      )}
      {permissionDenied && (
        <>
          <p className="text-[#859692] mb-6">
            Seems like the permission to access your location was denied.
          </p>
          <Button
            href="https://robots.net/tech/how-do-i-enable-location-permission-in-my-browser/"
            target="_blank"
            asChild
          >
            <a>Learn more</a>
          </Button>
        </>
      )}
    </div>
  );
};

export default LocationPermissionUI;
